import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { DtAddressService } from '../../../service/dt-address/dt-address.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { DeliRouteService } from '../../../service/deli-route/deli-route.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { PrefService } from '../../../service/pref/pref.service';
import { TypeShipInvoiceService } from '../../../service/type-shipinvoice/type-shipinvoice.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa9143',
  templateUrl: './wa9143.component.html',
  styleUrls: ['./wa9143.component.scss']
})
export class Wa9143Component implements OnInit {
  public componentTitle = 'WA9143:届先マスタ修正';

  public dtaddressId: number;
  public dtaddressCd: FormControl;
  public dtnameTx: FormControl;
  public dtpostalCd: FormControl;
  public dtaddress1Tx: FormControl;
  public dtaddress2Tx: FormControl;
  public dtaddress3Tx: FormControl;
  // public dtdepartmentTx: FormControl;
  public dttelTx: FormControl;
  public validation = validation;

  public owners: any;
  public carriers: any;
  public prefs: any;
  public deliroutes: any;
  public typeshipinvoices: any;

  public ownerTx: string;
  public ownerId: number;
  public updcounterNr: number;
  public prefTx: string;
  public carrierCd: FormControl;
  public delirouteId: FormControl;
  public delirouteCd: string;
  public typeshipinvoiceCd: string;
  public freeItem1Tx: FormControl;
  public freeItem2Tx: FormControl;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public rootFormGroup: FormGroup;
  public dump = '';
  private errorInfo = '';

  private ownerIdCls = '';
  private dtaddressCdCls = '';
  private dtnameTxCls = '';
  private dtpostalCdCls = '';
  private dtaddress1TxCls = '';
  private dtaddress2TxCls = '';
  private dtaddress3TxCls = '';
  private dttelTxCls = '';
  private carrierCdCls = '';
  private delirouteIdCls = '';
  private typeshipinvoiceCdCls = '';
  private freeItem1TxCls = '';
  private freeItem2TxCls = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private item = null;

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private carrierService: CarrierService,
    private prefService: PrefService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private formbuilder: FormBuilder,
    private dtAddressService: DtAddressService,
    private deliRouteService: DeliRouteService,
    private typeShipInvoiceService: TypeShipInvoiceService
  ) {
    this.dtaddressCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.dtaddressCd.maxLength)
    ]);
    this.dtnameTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtnameTx.maxLength)
    ]);
    this.dtpostalCd = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.pattern(validation.dtpostalCd.postcode),
      Validators.maxLength(validation.dtpostalCd.maxLength)
    ]);
    this.dtaddress1Tx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress1Tx.maxLength)
    ]);
    this.dtaddress2Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress2Tx.maxLength)
    ]);
    this.dtaddress3Tx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.dtaddress3Tx.maxLength)
    ]);
    // this.dtdepartmentTx = new FormControl(this.dtdepartmentTx, [
    //   Validators.pattern(validation.emBlankOnly),
    //   Validators.pattern(validation.halfBlankOnly),
    //   Validators.maxLength(validation.dtdepartmentTx.maxLength),
    // ]);
    this.dttelTx = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.dttelTx.tel),
      Validators.maxLength(validation.dttelTx.maxLength)
    ]);

    this.carrierCd = new FormControl('', [
      Validators.required
    ]);
    this.delirouteId = new FormControl('', [
      Validators.required
    ]);
    this.freeItem1Tx = new FormControl('', [
      Validators.maxLength(validation.freeItem1Tx.maxLength)
    ]);
    this.freeItem2Tx = new FormControl('', [
      Validators.maxLength(validation.freeItem2Tx.maxLength)
    ]);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;

    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.prefService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.prefs = __outputJson.prefs;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.deliRouteService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.deliroutes.push({ delirouteId: 0, delirouteTx: '選択しない' });
        this.deliroutes = __outputJson.deliroutes;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typeShipInvoiceService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        __outputJson.typeshipinvoices.push({ typeshipinvoiceCd: '', typeshipinvoiceTx: '選択しない' });
        this.typeshipinvoices = __outputJson.typeshipinvoices;
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    let errors = false;
    var dtnameTx = this.dtnameTx.value.trim();
    var dtpostalCd = this.dtpostalCd.value.trim();
    var dtaddress1Tx = this.dtaddress1Tx.value.trim();
    var dtaddress2Tx = this.dtaddress2Tx.value.trim();
    var dtaddress3Tx = this.dtaddress3Tx.value.trim();
    var freeItem1Tx = this.freeItem1Tx.value;
    if(freeItem1Tx != null){
      freeItem1Tx = freeItem1Tx.trim();
    }
    var freeItem2Tx = this.freeItem2Tx.value;
    if(freeItem2Tx != null){
      freeItem2Tx = freeItem2Tx.trim();
    }
    var dttelTx = this.dttelTx.value.trim();

    if (this.dtnameTx.errors !== null) {
      this.dtnameTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtpostalCd.errors !== null) {
      this.dtpostalCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtaddress1Tx.errors !== null) {
      this.dtaddress1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtaddress2Tx.errors !== null) {
      this.dtaddress2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.dtaddress3Tx.errors !== null) {
      this.dtaddress3Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    // if (this.dtdepartmentTx.errors !== null) {
    //   this.dtdepartmentTx.markAsTouched({ onlySelf: true });
    //   errors = true;
    // }
    if (this.dttelTx.errors !== null) {
      this.dttelTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.freeItem1Tx.errors !== null) {
      this.freeItem1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.freeItem2Tx.errors !== null) {
      this.freeItem2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (errors) {
      return;
    }

    if (this.ownerId === undefined) {
      this.errorInfo = '荷主を選択してください。';
      return;
    }
    if (this.carrierCd.value === undefined) {
      this.errorInfo = '配送方法を選択してください';
      return;
    }
    if (this.delirouteId === undefined) {
      this.errorInfo = '配送ルート名を選択してください';
      return;
    } else {
      if (this.delirouteId.value == 0) {
        this.delirouteCd = '';
      } else {
        for (let i = 0; i < this.deliroutes.length; i++) {
          if (this.deliroutes[i]['delirouteId'] == this.delirouteId) {
            this.delirouteCd = this.deliroutes[i]['delirouteCd'];
          }
        }
      }
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.dtAddressService
      .put(
        this.ownerId,
        this.updcounterNr,
        this.dtaddressId,
        this.dtaddressCd.value,
        dtnameTx,
        dtpostalCd,
        dtaddress1Tx,
        dtaddress2Tx,
        dtaddress3Tx,
        '',
        dttelTx,
        this.carrierCd.value,
        this.delirouteId.value,
        this.delirouteCd,
        this.typeshipinvoiceCd,
        freeItem1Tx,
        freeItem2Tx,
        'wa9143'
      )
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem('rowItems');
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const dtaddressSelect: object = JSON.parse(sessionStorage.getItem('rowItem'));
    this.item = dtaddressSelect;

    this.ownerTx = dtaddressSelect['ownerTx'];
    this.ownerId = dtaddressSelect['ownerId'];
    this.updcounterNr = dtaddressSelect['updcounterNr'];
    this.dtaddressId = dtaddressSelect['dtaddressId'];
    this.dtaddressCd.setValue(dtaddressSelect['dtaddressCd']);
    this.dtnameTx.setValue(dtaddressSelect['dtnameTx']);
    this.dtpostalCd.setValue(dtaddressSelect['dtpostalCd']);
    this.dtaddress1Tx.setValue(dtaddressSelect['dtaddress1Tx']);
    this.dtaddress2Tx.setValue(dtaddressSelect['dtaddress2Tx']);
    this.dtaddress3Tx.setValue(dtaddressSelect['dtaddress3Tx']);

    this.carrierCd.setValue(dtaddressSelect['carrierCd']);
    this.delirouteId.setValue(dtaddressSelect['delirouteId']);
    this.dttelTx.setValue(dtaddressSelect['dttelTx']);
    this.typeshipinvoiceCd = dtaddressSelect['typeshipinvoiceCd'];
    this.freeItem1Tx.setValue(dtaddressSelect['freeItem1Tx']);
    this.freeItem2Tx.setValue(dtaddressSelect['freeItem2Tx']);

    this.dtaddressCd.disable();
  }

  ngDoCheck() {
    if ((!this.isShow) || this.item == null)
      return;

    this.ownerIdCls = this.ownerId == this.item['ownerId'] ? '' : (this.ownerId + '' === '' ? this.STRINGS_ERROR : this.STRINGS_ACTIVE);
    this.dtaddressCdCls = this.dtaddressCd.value === this.item['dtaddressCd'] ? '' : (this.dtaddressCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtnameTxCls = this.dtnameTx.value === this.item['dtnameTx'] ? '' : (this.dtnameTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtpostalCdCls = this.dtpostalCd.value === this.item['dtpostalCd'] ? '' : (this.dtpostalCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress1TxCls = this.dtaddress1Tx.value === this.item['dtaddress1Tx'] ? '' : (this.dtaddress1Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress2TxCls = this.dtaddress2Tx.value === this.item['dtaddress2Tx'] ? '' : (this.dtaddress2Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dtaddress3TxCls = this.dtaddress3Tx.value === this.item['dtaddress3Tx'] ? '' : (this.dtaddress3Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.dttelTxCls = this.dttelTx.value === this.item['dttelTx'] ? '' : (this.dttelTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.carrierCdCls = this.carrierCd.value === this.item['carrierCd'] ? '' : (this.carrierCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.delirouteIdCls = this.delirouteId.value + '' === this.item['delirouteId'] ? '' : (this.delirouteId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.typeshipinvoiceCdCls = (this.typeshipinvoiceCd == null || this.typeshipinvoiceCd + '' === this.item['typeshipinvoiceCd']) ? '' : this.STRINGS_ACTIVE;
    this.freeItem1TxCls = this.freeItem1Tx.value === this.item['freeItem1Tx'] ? '' : (this.freeItem1Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.freeItem2TxCls = this.freeItem2Tx.value === this.item['freeItem2Tx'] ? '' : (this.freeItem2Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR);
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.dtnameTxCls !== this.STRINGS_ERROR &&
      this.dtpostalCdCls !== this.STRINGS_ERROR &&
      this.dtaddress1TxCls !== this.STRINGS_ERROR &&
      this.dtaddress2TxCls !== this.STRINGS_ERROR &&
      this.dtaddress3TxCls !== this.STRINGS_ERROR &&
      this.dttelTxCls !== this.STRINGS_ERROR &&
      this.carrierCdCls !== this.STRINGS_ERROR &&
      this.typeshipinvoiceCdCls !== this.STRINGS_ERROR &&
      this.freeItem1TxCls !== this.STRINGS_ERROR &&
      this.freeItem2TxCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.dtnameTxCls === this.STRINGS_ACTIVE ||
        this.dtpostalCdCls === this.STRINGS_ACTIVE ||
        this.dtaddress1TxCls === this.STRINGS_ACTIVE ||
        this.dtaddress2TxCls === this.STRINGS_ACTIVE ||
        this.dtaddress3TxCls === this.STRINGS_ACTIVE ||
        this.dttelTxCls === this.STRINGS_ACTIVE ||
        this.carrierCdCls === this.STRINGS_ACTIVE ||
        this.typeshipinvoiceCdCls === this.STRINGS_ACTIVE ||
        this.freeItem1TxCls === this.STRINGS_ACTIVE ||
        this.freeItem2TxCls === this.STRINGS_ACTIVE;
    }
    else {
      this.isSubmitButtonEnabled = false;
    }
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9143/wa9143.component.ts